import { createFileRoute } from '@tanstack/react-router'
import EmplacementsTab from '@features/stock/components/EmplacementsTab'

export const Route = createFileRoute('/_app/stock/emplacements/')({
  component: EmplacementsTab,
})
